<mat-card class="file-panel source-panel mip-panel">
  <mat-card-header>
    <mat-card-title>
      Medical images (DICOM discs) in Clio
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="loading"
         class="mip-state"
         role="status">
      <mat-spinner [diameter]="28"></mat-spinner>
      <span>Looking for DICOM discs in Clio...</span>
    </div>

    <div *ngIf="!loading && error"
         class="mip-state mip-error"
         role="alert">
      <span>{{error}}</span>
      <button mat-stroked-button
              type="button"
              (click)="retryRequested.emit()">
        Try again
      </button>
    </div>

    <div *ngIf="!loading && !error && discs.length === 0"
         class="mip-state">
      <mat-icon>
        album
      </mat-icon>
      <div>
        <strong>No DICOM discs found here.</strong>
        <div class="mip-muted">
          Only documents can be shared from this matter. Switch to All files to see them.
        </div>
      </div>
    </div>

    <ng-container *ngIf="!loading && !error && discs.length > 0">
      <p class="mip-hint">
        Tick a disc to import it as a DISC, or open it and tick only the studies you want.
        Images are imported as studies, not as loose files.
      </p>
      <p *ngIf="truncated"
         class="mip-warning">
        This matter is large, so not every folder was searched. Open the folder that holds the disc to search inside it.
      </p>

      <div class="mip-list">
        <div *ngFor="let disc of visibleDiscs; trackBy: trackDisc"
             class="mip-disc">
          <div class="mip-disc-row">
            <button class="mip-toggle"
                    type="button"
                    [attr.aria-expanded]="!!expanded[disc.folderId]"
                    [attr.aria-label]="(expanded[disc.folderId] ? 'Collapse ' : 'Expand ') + disc.name"
                    (click)="toggleExpanded(disc)">
              <mat-icon>
                {{expanded[disc.folderId] ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
            <mat-checkbox [attr.aria-label]="'Import all studies of ' + disc.name"
                          [checked]="pickState(disc) === 'all'"
                          [disabled]="!!disc.error || disc.studies.length === 0"
                          [indeterminate]="pickState(disc) === 'some'"
                          (change)="onDiscChecked(disc, $event.checked)">
            </mat-checkbox>
            <mat-icon class="mip-disc-icon">
              album
            </mat-icon>
            <div class="mip-disc-name">
              <strong>{{disc.name}}</strong>
              <span class="mip-muted">{{disc.path}}</span>
            </div>
            <span class="mip-badge"
                  *ngIf="!disc.error">
              {{disc.studies.length}} {{disc.studies.length === 1 ? 'study' : 'studies'}}
            </span>
            <span class="mip-badge mip-badge-on"
                  *ngIf="pickState(disc) === 'all'">
              Import as DISC
            </span>
            <span class="mip-badge mip-badge-on"
                  *ngIf="pickState(disc) === 'some'">
              Selected studies only
            </span>
          </div>

          <div *ngIf="disc.error"
               class="mip-disc-error">
            {{disc.error}}
          </div>

          <div *ngIf="expanded[disc.folderId] && !disc.error"
               class="mip-studies">
            <div *ngFor="let study of disc.studies; trackBy: trackStudy"
                 class="mip-study-row">
              <mat-checkbox [attr.aria-label]="'Import ' + (study.studyDescription || 'study')"
                            [checked]="isStudyChecked(disc, study.studyUID)"
                            (change)="onStudyChecked(disc, study.studyUID, $event.checked)">
              </mat-checkbox>
              <div class="mip-study-main">
                <span>{{study.studyDescription || 'Study without description'}}</span>
                <span class="mip-muted">{{study.patientName}}</span>
              </div>
              <span class="mip-study-meta">{{formatDate(study.studyDate)}}</span>
              <span class="mip-study-meta">{{study.modalities.join(', ')}}</span>
              <span class="mip-study-meta">{{study.imageCount}} images</span>
            </div>
            <div *ngIf="disc.studies.length === 0"
                 class="mip-muted mip-study-row">
              No studies found in the disc index.
            </div>
          </div>
        </div>
      </div>

    </ng-container>
  </mat-card-content>
</mat-card>
